import React from "react";
import { Card, Typography } from "antd";

const { Title, Text } = Typography;

interface BreakdownType {
  total?: number;
  supervisors?: number;
  staff?: number;
  thirdParty?: number;
  running?: number;
  completed?: number;
}

interface OrderStatusCardProps {
  title: string;
  borderColor: string;
  numberColor: string;
  breakdown?: BreakdownType;
  hideProgress?: boolean;
  percent?: number;
  percentLabel?: string;
  progressColor?: string;
  onClick?: () => void; // ✅ Add this
}

const OrderStatusCard: React.FC<OrderStatusCardProps> = ({
  title,
  borderColor,
  numberColor,
  breakdown,
  hideProgress = true,
  percent,
  percentLabel,
  progressColor,
  onClick
}) => {
  return (
    <Card
      className={`h-full border-l-4 ${borderColor} bg-white shadow-md rounded-lg`}
      bodyStyle={{ padding: "20px" }}
      onClick={onClick} // ✅ Add click handler
      hoverable
    >
      <div>
        <Title level={4} className="mb-3 text-gray-800 font-semibold">
          {title}
        </Title>

        <div className="space-y-2 text-sm font-medium">
          {breakdown?.total !== undefined && (
            <div className="flex justify-between">
              <Text className="text-gray-600">Total</Text>
              <Text className="font-semibold text-red-500">
                {breakdown.total}
              </Text>
            </div>
          )}
          {breakdown?.running !== undefined && (
            <div className="flex justify-between">
              <Text className="text-green-600">Running</Text>
              <Text className="text-yellow-500 font-semibold">
                {breakdown.running}
              </Text>
            </div>
          )}
          {breakdown?.completed !== undefined && (
            <div className="flex justify-between">
              <Text className="text-gray-600">Completed</Text>
              <Text className="text-green-600 font-semibold">
                {breakdown.completed}
              </Text>
            </div>
          )}

          {breakdown?.supervisors !== undefined && (
            <div className="flex justify-between">
              <Text className="text-purple-600">Supervisors</Text>
              <Text>{breakdown.supervisors}</Text>
            </div>
          )}
          {breakdown?.staff !== undefined && (
            <div className="flex justify-between">
              <Text className="text-blue-600">Staff</Text>
              <Text>{breakdown.staff}</Text>
            </div>
          )}
          {breakdown?.thirdParty !== undefined && (
            <div className="flex justify-between">
              <Text className="text-cyan-600">Third Party</Text>
              <Text>{breakdown.thirdParty}</Text>
            </div>
          )}
        </div>

        {!hideProgress && percent !== undefined && (
          <div className="mt-4">
            <div className="h-2 rounded bg-gray-200 w-full">
              <div
                className="h-2 rounded"
                style={{
                  width: `${percent}%`,
                  backgroundColor: progressColor,
                }}
              />
            </div>
            <Text className="text-sm text-gray-500 mt-2 block">
              {percentLabel}
            </Text>
          </div>
        )}
      </div>
    </Card>
  );
};

export default OrderStatusCard;
